import { InteractionRequiredAuthError } from '@azure/msal-browser';

const knownInteractionRequiredCodes = new Set(['interaction_required', 'login_required', 'consent_required']);

export const isInteractionRequiredAuthError = (error: unknown): boolean => {
    if (error instanceof InteractionRequiredAuthError) {
        return true;
    }

    if (!error || typeof error !== 'object') {
        return false;
    }

    const candidate = error as {
        name?: unknown;
        errorCode?: unknown;
        subError?: unknown;
    };

    const name = typeof candidate.name === 'string' ? candidate.name : '';
    const errorCode = typeof candidate.errorCode === 'string' ? candidate.errorCode.toLowerCase() : '';
    const subError = typeof candidate.subError === 'string' ? candidate.subError.toLowerCase() : '';

    return (
        name === 'InteractionRequiredAuthError' ||
        knownInteractionRequiredCodes.has(errorCode) ||
        knownInteractionRequiredCodes.has(subError)
    );
};